var map = {
	"./Favicon.png": 463,
	"./catalogo.png": 942,
	"./catalogoNegative.png": 943,
	"./catalogo_logo.png": 944,
	"./circle_black.svg": 464,
	"./circle_blue.svg": 465,
	"./clientLogo.png": 945,
	"./ellipse_black.svg": 466,
	"./france.svg": 282,
	"./highlighted_yellow.svg": 467,
	"./icone": 20,
	"./icone/": 20,
	"./icone/AddCarrello.icona": 252,
	"./icone/AddCarrello.icona.js": 252,
	"./icone/AddLista.icona": 253,
	"./icone/AddLista.icona.js": 253,
	"./icone/Allegato.icona": 254,
	"./icone/Allegato.icona.js": 254,
	"./icone/ArrowLx.icona": 244,
	"./icone/ArrowLx.icona.js": 244,
	"./icone/ArrowRx.icona": 246,
	"./icone/ArrowRx.icona.js": 246,
	"./icone/ArrowsLx.icona": 245,
	"./icone/ArrowsLx.icona.js": 245,
	"./icone/ArrowsRx.icona": 247,
	"./icone/ArrowsRx.icona.js": 247,
	"./icone/Carosello.icona": 267,
	"./icone/Carosello.icona.js": 267,
	"./icone/Carrello.icona": 221,
	"./icone/Carrello.icona.js": 221,
	"./icone/Categorie.icona": 222,
	"./icone/Categorie.icona.js": 222,
	"./icone/Close.icona": 224,
	"./icone/Close.icona.js": 224,
	"./icone/Close_.icona": 223,
	"./icone/Close_.icona.js": 223,
	"./icone/Condividi.icona": 225,
	"./icone/Condividi.icona.js": 225,
	"./icone/CondividiNew.icona": 255,
	"./icone/CondividiNew.icona.js": 255,
	"./icone/Curiosita.icona": 256,
	"./icone/Curiosita.icona.js": 256,
	"./icone/Curiosita2.icona": 257,
	"./icone/Curiosita2.icona.js": 257,
	"./icone/EliminaCarrello.icona": 258,
	"./icone/EliminaCarrello.icona.js": 258,
	"./icone/EliminaLista.icona": 259,
	"./icone/EliminaLista.icona.js": 259,
	"./icone/Indice.icona": 268,
	"./icone/Indice.icona.js": 268,
	"./icone/Informazioni.icona": 226,
	"./icone/Informazioni.icona.js": 226,
	"./icone/LinkEsterno.icona": 260,
	"./icone/LinkEsterno.icona.js": 260,
	"./icone/LinkInterno.icona": 261,
	"./icone/LinkInterno.icona.js": 261,
	"./icone/ListaSpesa.icona": 250,
	"./icone/ListaSpesa.icona.js": 250,
	"./icone/Login.icona": 270,
	"./icone/Login.icona.js": 270,
	"./icone/Logout.icona": 269,
	"./icone/Logout.icona.js": 269,
	"./icone/Mappa.icona": 227,
	"./icone/Mappa.icona.js": 227,
	"./icone/Negozio.icona": 262,
	"./icone/Negozio.icona.js": 262,
	"./icone/Pagine.icona": 228,
	"./icone/Pagine.icona.js": 228,
	"./icone/Pdf.icona": 229,
	"./icone/Pdf.icona.js": 229,
	"./icone/Plus.icona": 170,
	"./icone/Plus.icona.js": 170,
	"./icone/PlusIperbimbo.icona": 284,
	"./icone/PlusIperbimbo.icona.js": 284,
	"./icone/Prodotti.icona": 230,
	"./icone/Prodotti.icona.js": 230,
	"./icone/Prodotto.icona": 265,
	"./icone/Prodotto.icona.js": 265,
	"./icone/ProdottoMano.icona": 266,
	"./icone/ProdottoMano.icona.js": 266,
	"./icone/QrCode.icona": 271,
	"./icone/QrCode.icona.js": 271,
	"./icone/Ricetta.icona": 511,
	"./icone/Ricetta.icona.js": 511,
	"./icone/Ricetta2.icona": 163,
	"./icone/Ricetta2.icona.js": 163,
	"./icone/SchedaTecnica.icona": 263,
	"./icone/SchedaTecnica.icona.js": 263,
	"./icone/SchermoIntero.icona": 241,
	"./icone/SchermoIntero.icona.js": 241,
	"./icone/Search.icona": 251,
	"./icone/Search.icona.js": 251,
	"./icone/Video.icona": 242,
	"./icone/Video.icona.js": 242,
	"./icone/Video2.icona": 264,
	"./icone/Video2.icona.js": 264,
	"./icone/VideoIperbibmo.icona": 285,
	"./icone/VideoIperbibmo.icona.js": 285,
	"./icone/Volantino.icona": 243,
	"./icone/Volantino.icona.js": 243,
	"./icone/ZoomIn.icona": 248,
	"./icone/ZoomIn.icona.js": 248,
	"./icone/ZoomOut.icona": 249,
	"./icone/ZoomOut.icona.js": 249,
	"./icone/carousel_new.svg": 512,
	"./icone/index": 20,
	"./icone/index.js": 20,
	"./icons/Cart.svg": 513,
	"./icons/Cart_add.svg": 514,
	"./icons/Cart_delete.svg": 515,
	"./icons/Cart_remove.svg": 516,
	"./icons/Informazioni.icon": 283,
	"./icons/Informazioni.icon.js": 283,
	"./icons/_info.svg": 517,
	"./icons/add_icon.svg": 286,
	"./icons/add_prod.png": 1093,
	"./icons/add_prod.svg": 518,
	"./icons/add_prodOLD.svg": 519,
	"./icons/ask.svg": 520,
	"./icons/carousel.svg": 358,
	"./icons/carrello.svg": 521,
	"./icons/categorie.svg": 522,
	"./icons/clear_chart.svg": 523,
	"./icons/clear_chartOLD.png": 1094,
	"./icons/clear_chart_.png": 1095,
	"./icons/close.png": 1096,
	"./icons/close.svg": 201,
	"./icons/close_.svg": 524,
	"./icons/condividi.svg": 525,
	"./icons/download_img.png": 1097,
	"./icons/email.svg": 360,
	"./icons/facebook.svg": 198,
	"./icons/fb.png": 408,
	"./icons/hatchef.svg": 349,
	"./icons/icone/_info.svg": 526,
	"./icons/icone/book-open-solid.svg": 342,
	"./icons/icone/columns-solid.svg": 343,
	"./icons/icone/file-pdf-solid.svg": 345,
	"./icons/icone/hatchef.svg": 527,
	"./icons/icone/info.svg": 528,
	"./icons/icone/list-solid.svg": 348,
	"./icons/icone/magnifying-glass-solid.svg": 344,
	"./icons/icone/play.svg": 529,
	"./icons/icone/plus.svg": 530,
	"./icons/icone/share-square-solid-prod.svg": 347,
	"./icons/icone/share-square-solid.svg": 346,
	"./icons/icone/specs.svg": 531,
	"./icons/icone/world.svg": 532,
	"./icons/index-icon-bookmark.svg": 533,
	"./icons/index-icon.svg": 534,
	"./icons/info.svg": 357,
	"./icons/informazioni.svg": 535,
	"./icons/internal_link.svg": 361,
	"./icons/mappa.svg": 536,
	"./icons/markers-SVG/ask.svg": 537,
	"./icons/markers-SVG/info.svg": 538,
	"./icons/markers-SVG/list.svg": 539,
	"./icons/markers-SVG/recipe.svg": 540,
	"./icons/markers-SVG/web.svg": 541,
	"./icons/new_list.png": 1098,
	"./icons/new_list_mobile.png": 1099,
	"./icons/new_list_white.png": 1100,
	"./icons/pagine.svg": 542,
	"./icons/pdf.svg": 543,
	"./icons/play.svg": 353,
	"./icons/play_ip.svg": 354,
	"./icons/plus.svg": 350,
	"./icons/plus_ip.svg": 351,
	"./icons/prodotti.svg": 544,
	"./icons/promo.svg": 356,
	"./icons/promo2.svg": 545,
	"./icons/promo3.svg": 546,
	"./icons/promo_10.svg": 547,
	"./icons/promo_classic.svg": 548,
	"./icons/remove_prod.svg": 549,
	"./icons/remove_prodOLD.svg": 550,
	"./icons/remove_prod_.svg": 551,
	"./icons/ricetta.svg": 552,
	"./icons/schermo_intero.svg": 553,
	"./icons/shop_list.svg": 554,
	"./icons/shpo-list.png": 1101,
	"./icons/specs.svg": 355,
	"./icons/telephone.svg": 359,
	"./icons/video.svg": 555,
	"./icons/volantino.svg": 556,
	"./icons/wa.png": 409,
	"./icons/whatsapp.svg": 199,
	"./icons/white_add_prod.png": 557,
	"./icons/white_add_prodOLD.png": 1102,
	"./icons/world.svg": 352,
	"./interattico_icon.png": 462,
	"./italian.png": 410,
	"./logo.png": 1103,
	"./logo_catalog_interattivo.svg": 558,
	"./logo_client.png": 559,
	"./logo_interattivo.png": 1104,
	"./logo_interattivo.svg": 560,
	"./logo_interattivo_free.png": 561,
	"./logo_interattivo_free.svg": 562,
	"./logo_interattivo_negative.png": 1105,
	"./logo_interattivo_new.svg": 380,
	"./logo_menu_interattivo.svg": 563,
	"./logo_new.png": 1106,
	"./logo_volantinointerattivo_free.svg": 381,
	"./menu.png": 1107,
	"./menuNegative.png": 1108,
	"./menu_logo.png": 1109,
	"./no_vol.png": 1110,
	"./no_vol_m.png": 1111,
	"./non-disponibile.png": 1112,
	"./prodotto.png": 564,
	"./spanishflag.png": 411,
	"./usaflag.png": 412
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 147;